export default "__VITE_ASSET__CZwIDtQ5__"